import $ from 'jquery';
import {extractShippingMethod} from '@wc-stripe/utils';
import BaseController from '../controllers/BaseController';

class ExpressCheckoutController extends BaseController {

    initActions() {
        this.actions.addAction('updated_checkout', this.onUpdatedCheckout.bind(this));
        this.actions.addAction('payment_intent_requires_actions', this.onPaymentRequiresAction.bind(this));
        this.actions.addAction('setup_intent_requires_actions', this.onPaymentRequiresAction.bind(this));
    }

    onUpdatedCheckout() {
        super.initialize();
    }

    onPaymentElementReady() {
        $(this.selector).show().addClass('active');
        $(this.selector).closest('.wc-stripe-banner-checkout').addClass('active');
        super.onPaymentElementReady();
    }

    onPaymentUnavailable() {
        super.onPaymentUnavailable();
        $(`li.banner_payment_method_${this.gateway.id}`).hide();
    }

    onClick() {
        // Auto-check terms and conditions
        $('[name="terms"]').prop('checked', true).trigger('change');

        // Select this payment method
        const $el = $(`[name="payment_method"][value="${this.gateway.id}"]`);
        $el.prop("checked", true).trigger('click');
        $el.trigger('change');

        // Select "new" payment token (not saved payment method)
        $(`[name="wc-${this.gateway.id}-payment-token"][value="new"]`).trigger('click');
    }

    async onShippingChange(data) {
        if (data?.shipping_method) {
            // check if shipping method already exists, if so select it
            const shippingMethods = extractShippingMethod(data.shipping_method);
            for (const idx in shippingMethods) {
                const method = shippingMethods[idx];
                const el = $(`[name="shipping_method[${idx}]"][value="${method}"]`);
                if (el.length) {
                    el.prop('checked', true);
                } else {
                    this._updateRequired = true;
                }
            }
        }
        return super.onShippingChange(data);
    }

    async onPaymentRequiresAction(data) {
        if (data.gateway_id === this.gateway.id && this.gateway.isPaymentSheetOpen()) {
            try {
                const result = await this.handleIntentConfirmation(data);
                window.location.href = this.getPostAuthenticationRedirectUrl(data, result);
            } catch (error) {
                this.gateway.clearElementSubmitted();
                this.gateway.setPaymentMethodId('');
                this.gateway.setSetupIntentId('');
                this.getForm().removeClass('processing').unblock?.();
                return this.submitError(error);
            }
        }
    }

    async submit(checkoutData = null) {
        if (checkoutData) {
            this.populateCheckoutFields(checkoutData);
        }

        if (this._updateRequired) {
            await this.triggerUpdatedCheckout();
        }

        // Make sure the payment_method radio button has the correct gateway ID
        // before submitting the form.
        $('[name="payment_method"]').val(this.gateway.id);

        this.actions.doAction('before_form_submit', this);

        this.getForm().trigger('submit');
    }

    populateCheckoutFields(data, options = {}) {
        super.populateCheckoutFields(data, options);
        // This code ensures that payment method ID is added to the form.
        // some themes might render the express checkout code outside the checkout form.
        if (data.paymentMethodId) {
            const key = `${this.gateway.id}_payment_method_id`;
            if (!$(`[name="${key}"]`).length) {
                $('form.checkout').append(`<input type="hidden" name="${key}" value="${data.paymentMethodId}" />`);
            }
        }
    }

    triggerUpdatedCheckout() {
        return new Promise((resolve) => {
            $(document.body).one('updated_checkout', resolve);
            // trigger change event on country fields in case 3rd party plugins are controlling these fields.
            $('[name="billing_country"], [name="shipping_country"]').trigger('change');
            $(document.body).trigger('update_checkout', {update_shipping_method: false});
        });
    }

    needsShipping() {
        return this.cart.needsShipping();
    }

    getForm() {
        return $(this.selector).closest('form');
    }
}

export default ExpressCheckoutController;